import { MDCRipple } from "@material/ripple";

// Function to initialize ripples
// export const initRipples = () => {
//   const selectors = '.btn, .mdc-ripple-surface';
//   const elements = document.querySelectorAll(selectors);
  
//   elements.forEach((el) => {
//     const ripple = new MDCRipple(el);
//     // Optional: If it's a small icon button, make it unbounded (circular)
//     if (el.classList.contains('btn-icon')) {
//       ripple.unbounded = true;
//     }
//   });
// };

export function initRipples() {
  initializeMaterialRipples();
}

function initializeMaterialRipples() {
  const ripples = document.querySelectorAll('.mdc-ripple-surface');
  ripples.forEach(el => {
    const r = new MDCRipple(el);
    // Because these are small circular buttons, 
    // 'unbounded' makes the ripple expand past the edges slightly (M3 style)
    r.unbounded = false; 
  });
}

// function initializeMaterialRipples() {
//   // 1. Initialize ripples for the CIRCULAR icon buttons (e.g., in footer/header)
//   const iconButtons = document.querySelectorAll('.btn-icon.mdc-ripple-surface');
//   iconButtons.forEach(el => {
//     const ripple = new MDCRipple(el);
//     // Unbounded means the circular ripple goes slightly past the square/circle bounds
//     ripple.unbounded = true; 
//   });

//   // 2. Initialize ripples for the navigation LINKS (e.g., in the drawer)
//   const navLinks = document.querySelectorAll('.offcanvas-body .nav-link.mdc-ripple-surface');
//   navLinks.forEach(el => {
//     const ripple = new MDCRipple(el);
//     // Bounded means the ripple is clipped exactly to the 'pill' shape you styled
//     // 'unbounded' defaults to false
//   });
// }